import Home from '@/pages/Home/Home.vue';
import Article from '@/pages/Article/Article.vue';
import AllArticles from '@/pages/Article/AllArticles.vue';
import Serie from '@/pages/Series/Serie.vue';
import AllSeries from '@/pages/Series/AllSeries.vue';
import AllNews from '@/pages/News/AllNews.vue';
import News from '@/pages/News/News.vue';
import Publisher from '@/pages/publisher/Publisher.vue';
import Contant from '@/pages/Contant/Contant.vue';
import PublishingRules from '@/pages/PublishingRules/PublishingRules.vue';
import EditorialBoard from '@/pages/EditorialBoard/EditorialBoard.vue';
import SearchResult from '@/pages/SearchResult/SearchResult.vue';
import AboutUs from '@/pages/AboutUs/AboutUs.vue';
import JoinUs from '@/pages/JoinUs/JoinUs.vue';

export default [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
	{
		path: '/serie-:serieId/:serieName/volume-:volumeId/:volumeName/article-:id/:name',
		name: 'article',
		component: Article,
		props: route => ({ 
			serieId: parseInt(route.params.serieId),
			serieName: route.params.serieName,
			volumeId: parseInt(route.params.volumeId),
			volumeName: route.params.volumeName,
			articleId: parseInt(route.params.id)
		})
	},
	{
		path: '/serie-:serieId/:serieName/volume-:id/:name/all-articles',
		name: 'all-articles',
		component: AllArticles,
		props: route => ({ 
			serieId: parseInt(route.params.serieId),
			serieName: route.params.serieName,
			volumeId: parseInt(route.params.id)
		})
	},
	{
		path: '/serie-:id/:name',
		name: 'serie',
		component: Serie,
		props: route => ({ serieId: parseInt(route.params.id) })
	},
	{
		path: '/all-series',
		name: 'all-series',
		component: AllSeries,
	},
	{
		path: '/news/:id',
		name: 'news',
		component: News,
	},
	{
		path: '/all-news',
		name: 'all-news',
		component: AllNews,
	},
	{
		path: '/publisher-:id/:name',
		name: 'publisher',
		component: Publisher,
		props: route => ({ publisherId: parseInt(route.params.id) })
	},
	{
		path: '/contant',
		name: 'contant',
		component: Contant,
	},
	{
		path: '/publishing-rules',
		name: 'publishing-rules',
		component: PublishingRules,
	},
	{
		path: '/editorial-board',
		name: 'editorial-board',
		component: EditorialBoard,
	},
	{
		path: '/search-result',
		name: 'search-result',
		component: SearchResult,
		props: route => ({
			search: route.query.search,
			issn: route.query.issn,
			startDate: route.query.startDate,
			endDate: route.query.endDate,
			keyword: route.query.keyword,
			article: route.query.article,
			publisher: route.query.publisher,
			serie: route.query.serie,
			volume: route.query.volume,
		})
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: AboutUs,
	},
	{
		path: '/join-us',
		name: 'join-us',
		component: JoinUs,
	},
];